import HostAnchor1 from './HostAnchor1.json';
import HostGoal1 from './HostGoal1.json';
import HostRisk1 from './HostRisk1.json';
import HostWind1 from './HostWind1.json';
import HostWind2 from './HostWind2.json';
import NegativeSticky1 from './NegativeSticky1.json';
import NegativeSticky2 from './NegativeSticky2.json';
import PositiveSticky1 from './PositiveSticky1.json';
import PositiveSticky2 from './PositiveSticky2.json';
import PositiveSticky3 from './PositiveSticky3.json';
import User1Step1 from './User1Step1.json';
import User2Step1 from './User2Step1.json';
import User3Step1 from './User3Step1.json';

export const Recordings = {
    User1Step1,
    User2Step1,
    User3Step1,
    PositiveSticky1,
    PositiveSticky2,
    PositiveSticky3,
    NegativeSticky1,
    NegativeSticky2,
    HostGoal1,
    HostRisk1,
    HostAnchor1,
    HostWind1,
    HostWind2,
};
